module.exports = __webpack_public_path__ + "static/media/5DPO11.1f966ae2.jpg";